<ngx-ui-loader></ngx-ui-loader>
<ngx-loading-bar color="#0097d8" [includeSpinner]="false"></ngx-loading-bar>
<app-push-notification></app-push-notification>
<router-outlet></router-outlet>
